module.exports = "/images/RoofPanel.png?4df2bbc2b0117225c2033378f3d5dccf";